<template>
  <div class="adaptation-plan">
    <top-nav :show-user="true" />
    <loading-progress v-if="isProcessing" data-position="fixed" />
    <div class="content-container">
      <button v-if="currentStep === 1" @click="currentStep = 0"
        class="btn btn-rounded white grey-text text-darken-3 waves-effect close-btn">
        <i class="material-icons grey-text text-darken-4 left">arrow_back</i>
        Back
      </button>
      <div class="right" :style="viewType === 'full' && previewMode
        ? `width: 130px; position: relative`
        : 'width: 170px; position: relative'
        ">
        <button @click="saveHack()" v-if="viewType === 'full' && currentStep === 1 && !previewMode"
          class="btn save-btn btn-rounded waves-effect indigo accent-2">
          <i class="material-icons-outlined left">save</i> Save &amp; Preview
        </button>

        <button v-else-if="viewType === 'full' && currentStep === 1 && previewMode" @click="previewMode = false"
          class="btn save-btn btn-rounded waves-effect indigo accent-2">
          <i class="material-icons-outlined left">edit</i> Edit View
        </button>

        <button v-if="viewType === 'full' && currentStep === 1 && previewMode" @click="printView()"
          class="btn-floating waves-effect white print-btn">
          <i class="material-icons-outlined grey-text text-darken-3">print</i>
        </button>
      </div>

      <div class="action-spacer" v-if="currentStep === 1"></div>
      <div class="content" v-if="currentStep === 0">
        <div class="section-title">
          Adaptation Plan
        </div>
        <div class="intro-element justify-text">
          <p>
            Your Adaptation Plan will identify and
            describe measures, such as home improvement
            projects, you wish to implement to reduce the impacts of
            climate change, including stronger
            hurricanes, on your home.
          </p>

          <p>
            You are also encouraged to develop a
            short Mitigation Plan to help limit
            global climate change by reducing your
            household's fossil fuel energy use.
          </p>
        </div>
        <div class="row">
          <div class="col s12 m6 right-align adapt-actions">
            <button @click="$_setView('step')" style="width: 220px"
              class="btn-medium white btn-rounded indigo-text text-accent-2 waves-effect">
              <i class="material-icons-outlined left indigo-text text-accent-2">not_started</i>
              Step-by-Step View
            </button>
          </div>

          <div class="col s12 m6 left-align adapt-actions">
            <button @click="$_setView('full')" style="width: 220px"
              class="btn-medium indigo btn-rounded accent-2 white-text waves-effect">
              <i class="material-icons-outlined left white-text">not_started</i>Full View
            </button>
          </div>

          <!-- <div class="col s12 or-text">
            - OR -
          </div>

          <div class="col s12 adaptation-section ">
            <adaptation-plan-upload />
          </div> -->
        </div>
      </div>
      <div class="content" v-if="currentStep > 0">
        <!--  <div class="section-title">
        SLDB Act to Adapt School Competition Adaptation Plan Outline
      </div> -->

        <div class="full-view" v-if="viewType === 'full'">
          <div class="instructions-view-full">
            <div class="step-index" v-for="(step, i) in stages" :key="step.id">
              <collapsible-component body-classes="padding-16 white" :is-open="false" :index="i" :check-default="true"
                v-if="!previewMode">
                <template #header>
                  <div class="title" v-html="step.title + ` ${step.word_count_text}`"></div>
                </template>
                <template #body>
                  <div class="description" v-html="step.instructions"></div>
                </template>
              </collapsible-component>
              <div v-else>
                <div class="preview-title" v-html="step.title"></div>
              </div>
              <div class="your-data-entry" style="margin-bottom:32px;" :class="[
                step.wordCount === step.maxCount ? 'disable-field' : '',
              ]">
                <block-editor v-if="!previewMode" :ref="`editor${i}`" @content="$_saveData($event, i)"
                  :content="step.value"></block-editor>
                <!--  <vue-editor class="hide"
                :customModules="customModulesForEditor"
                 v-if="!previewMode"
                 :editorOptions="editorSettings"
                 v-on:ready="(quill) => (editorQuill[i] = quill)"
                 :value="step.value" @input="$_saveData($event, i)" :editor-toolbar="toolbar" /> -->
                <div v-else class="col s12 justify-text">
                  <div v-html="step.value"></div>
                </div>
                <div class="word-count" v-if="!previewMode" :class="step.wordCount > step.maxCount ? 'red white-text' : ''
                  ">
                  <span class="actual-count">{{ step.wordCount }} Words</span>
                  <span class="wce" v-if="step.wordCount > step.maxCount">
                    - Maximum word count exceeded.</span>
                </div>
              </div>
            </div>
          </div>

          <div class="adaptation-plan-end">
            <router-link tag="button" :to="{ name: 'Home' }" class="btn-large btn-rounded waves-effect indigo accent-2">
              Finish
            </router-link>
          </div>
        </div>
        <div class="step-by-step" v-else>
          <div class="step-index" :key="stages[activeStage].id">
            <collapsible-component body-classes="padding-16 white" :is-open="false" :index="activeStage"
              :check-default="true">
              <template #header>
                <div class="title" v-html="stages[activeStage].title +
                  ` ${stages[activeStage].word_count_text}`
                  "></div>
              </template>
              <template #body>
                <div class="description" v-html="stages[activeStage].instructions"></div>
              </template>
            </collapsible-component>

            <div class="your-data-entry">
              <!--        <vue-editor
                v-on:ready="(quill) => (editorQuill[activeStage] = quill)"
                :editor-toolbar="toolbar"
                :value="stages[activeStage].value"
                @input="$_saveData($event, activeStage)"
                :ref="`toolBar` + activeStage"
              /> -->
              <block-editor v-if="!previewMode" :ref="`editor${activeStage}`" @content="$_saveData($event, activeStage)"
                :content="stages[activeStage].value"></block-editor>

              <div class="word-count" :class="stages[activeStage].wordCount > stages[activeStage].maxCount
                ? 'red white-text'
                : ''
                ">
                <span class="actual-count">{{ stages[activeStage].wordCount }} Words</span>
                -
                <span class="wce" v-if="stages[activeStage].wordCount > stages[activeStage].maxCount
                  ">Maximum word count exceeded.</span>
              </div>
            </div>
          </div>
          <div class="step-navigation">
            <button @click="activeStage -= 1" :disabled="activeStage === 0"
              class="btn btn-rounded white  indigo-text text-accent-2 waves-effect">
              Previous
            </button>
            <button @click="regularSave()" class="btn btn-rounded waves-effect indigo accent-2">
              <i class="material-icons-outlined left">save</i> Save
              <span class="hide-on-small-only">Progress</span>
            </button>
            <button v-if="activeStage !== stages.length - 1" @click="activeStage += 1"
              :disabled="activeStage === stages.length - 1" class="btn btn-rounded indigo accent-2 waves-effect">
              Next
            </button>
            <router-link :to="{ name: 'Home' }" v-else class="btn btn-rounded indigo accent-2 right waves-effect">
              Finish
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <app-bottom-tab />
  </div>
</template>
<script>
import collapsibleComponent from "@/components/collapsible.component.vue";
import { updateUserProfile } from "@/api/user.api";
import { toastMessage } from "@/common/util";
import { mapState, mapActions } from "vuex";
import { VueEditor } from "vue2-editor";
import blockEditor from "@/components/contentEditor.component";

import topNav from "@/components/topNav";
import AppBottomTab from "@/components/AppBottomTab";
import AdaptationPlanUpload from "../../components/AdaptationPlan/AdaptationPlanUpload.vue";

export default {
  name: "adaptationPlan",
  components: {
    topNav,
    AppBottomTab,
    VueEditor,
    blockEditor,
    collapsibleComponent,
    AdaptationPlanUpload,
  },
  data() {
    return {
      previewMode: false,
      isProcessing: false,
      editorQuill: [],
      customModulesForEditor: [
        /*      { alias: "imageResize", module: ImageResize } */
      ],
      editorSettings: {
        modules: {},
      },
      currentStep: 0,
      toolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"],
      ],
      viewType: `full`,
      activeEditor: 0,
      activeStage: 0,
      stages: [
        {
          id: 1,
          title: "Introduction",
          word_count_text: `(Max: 150 words)`,
          instructions: /* html */ `
          <ul class="browser-default">
            <li>Use the information from your Home Profile to provide a brief description of your home. Include a description of its location, construction (type of building, size, materials, age), general condition and occupancy. </li>
            <li>Insert at least one photo of the full house and its environs. </li>
          </ul>
          `,
          value: ``,
          wordCount: 0,
          maxCount: 150,
          images: [],
        },
        {
          id: 2,
          title: "Climate Change Risk Profile",
          word_count_text: `(Max: 250 words)`,
          instructions: /* html */ `
          <ul class="browser-default">
            <li>Summarize the expected impact level from each hazard assessed (wind, flood and water shortage) as determined by the Climate Change Home Risk Assessment. </li>
            <li>Discuss which hazards and key vulnerabilities you have prioritized for addressing through implementation of adaptation measures and explain why. This section is important as it forms the rationale for the adaptation measures/projects proposed. (Remember, the judges will have the full Assessment results so keep your summary to 0.5 pages). </li>
            <li>Support this section by including photos that show the key structural or contextual vulnerabilities revealed by the Climate Change Home Risk Assessment. </li>
          </ul>
          `,
          value: ``,
          wordCount: 0,
          maxCount: 250,
          images: [],
        },
        {
          id: 3,
          title: "Carbon Footprint Profile",
          word_count_text: `(Max: 150 words)`,
          instructions: /* html */ `
            </p>Summarize the results of the Household Carbon Footprint Calculator and discuss your home’s relative contribution to global
            climate change (based on typical household carbon footprints). Is your carbon footprint higher, lower or in keeping with local,
            regional and global averages? Discuss the major factors that contribute to your household’s carbon footprint and
            identify where you could make improvements and whether these improvements are priorities in the context of
            your wider Assessment results. </p>
          `,
          value: ``,
          wordCount: 0,
          maxCount: 150,
          images: [],
        },
        {
          id: 4,
          title: "Adaptation (and Mitigation) Measures/Projects",
          word_count_text: `(Max: 1,500 words)`,
          instructions: /* html */ `
          <b>ADAPTATION MEASURES</b>
          <ul class="browser-default">
            <li>For each priority hazard (e.g. wind hazard), clearly identify the home improvement project(s) proposed to reduce the expected impact to your home. Make sure your adaptation measures clearly relate to and address the major source(s) of vulnerability identified for each priority hazard. Explain the expected benefits of each proposed adaptation measure/project and why it is the most appropriate solution for your home. If you proposed multiple measures/projects, briefly explain how they complement each other. Consult the Resource Centre for ideas! </li>
            <li>Estimate and present the cost to implement each adaptation measure/project proposed. Breakdown the cost into the main factors such as materials, equipment and labour costs.  </li>
            <li>Don’t forget to talk to your parents about your priorities. </li>
          </ul>
          <b>MITIGATION MEASURES (optional) </b>
          <ul class="browser-default">
            <li>While the focus of most plans will be adaptation measures (projects to make your home more resilient), depending on the results of your Assessment, your Plan may include or even focus on mitigation measures (projects to reduce your home’s carbon footprint). If adaptation measures are your priority, there is no penalty for excluding mitigative measures. On the other hand, if your home is already as resilient as possible, your grant Plan can just focus on mitigation measures, including energy conservation, energy efficiency and alternative energy projects. In addition to thinking about alternative energy projects (e.g. solar energy and solar water heaters) for decreasing your carbon footprint, you can also think about these from an adaptation perspective as they can increase your resilience to prolonged power outages following disaster events. </li>
            <li>In this section, describe the mitigation measures you wish to implement and explain why these are priority investments, including discussing the expected benefits, such as reducing your carbon footprint and energy bill while increasing your level of energy independence and security.</li>
            <li>Don’t forget to talk to your parents about your priorities.</li>
          </ul>
          `,
          value: ``,
          wordCount: 0,
          maxCount: 1500,
          images: [],
        },
        {
          id: 5,
          title: "Implementation Plan",
          word_count_text: `(Max: 250 words)`,
          instructions: /* html */ `
          <ul class="browser-default">
            <li>Describe how your family will implement the adaptation and mitigation measures proposed, including who will do the work (family members, contractors or both), whether the family will contribute financially, when you will carry out the project(s), how long it will take and other aspects of implementation you want to include. </li>
            <li>Describe the implementation plan for all measures proposed, including overall timeline, phasing, persons/professionals responsible for implementation and budget.</li>
          </ul>
          `,
          value: ``,
          wordCount: 0,
          maxCount: 250,
          images: [],
        },
      ],
    };
  },
  beforeDestroy() {
    //this.$_saveToApi();
  },
  watch: {
    wordCount: function () { },
    currentStep: function (nV) {
      this.editorQuill = [];
      nV === 0 ? (this.activeStage = 0) : "";
      this.previewMode = false;
    },
  },
  mounted() {
    if (this.adaptationPlanX.length > 0) {
      this.stages.forEach((a) => {
        let record = this.adaptationPlanX.find(
          (x) => parseInt(x.section.id) === parseInt(a.id)
        );
        if (record) {
          a.value = record.section.value;
          a.wordCount = record.section.word_count;
        }
        //   record ? (a.value = record.section.value) : (a.value = "");
      });
    }

    /*     let getAValue = () => {
      this.adaptationPlan
    } */
    /*  this.adaptationPlan && this.adaptationPlan.length > 0
    ? this.stages.forEach((x,i) => { x.value = this.adaptationPlan.find(v => x.id === v.id).value })
    : '' */
    /*   setTimeout(() => {
      this.ready = true
    }, 100); */
  },
  computed: {
    ...mapState({ user: (state) => state.User.user }),
    adaptationPlan: {
      get() {
        return this.user.adaptation_plan
          ? JSON.parse(this.user.adaptation_plan)
          : false;
      },
    },
    adaptationPlanX: {
      get() {
        return this.user.adaptation_planX ? this.user.adaptation_planX : false;
      },
    },
    /*    wordCount: {
      get() {
      let filecont = this.editorQuill.length > 0 ?  this.editorQuill[this.activeStage].getText() : false
      return filecont && filecont.match(/\w+/g) ? filecont.match(/\w+/g).length : 0;
      }
    }, */
  },
  methods: {
    ...mapActions("User", ["updateUser"]),
    printView() {
      window.print();
    },
    regularSave() {
      this.$_saveToApi(true);
    },
    saveHack() {
      this.isProcessing = true;
      setTimeout(() => {
        this.isProcessing = false;
        !this.previewMode
          ? (this.previewMode = true)
          : (this.previewMode = false);
      }, 1500);
    },
    $_wordWatch() {
      let x = 0;
      // console.log(x ++)
      // let filecont = this.editorQuill[this.activeStage].getText()
      let fileCountTwo = () => {
        let div = document.createElement("DIV");
        // div.innerHTML = this.$refs[`editor${this.activeStage}`][0].content
        this.viewType === "step"
          ? (div.innerHTML = this.$refs[`editor${this.activeStage}`].content)
          : (div.innerHTML = this.$refs[
            `editor${this.activeStage}`
          ][0].content);
        return div.textContent;
        /* .innerHTML =  this.$refs[`editor${this.activeStage}`][0].content */
      };
      let wordC = fileCountTwo().match(/\w+/g)
        ? fileCountTwo().match(/\w+/g).length
        : 0;
      // console.log(wordC)
      return wordC;
    },
    $_saveData(e, i) {
      this.activeStage = i;
      // console.log(e)
      //console.log(e.match(/<p(.).*?<\/p\b[^>]*>/ig))
      this.stages[this.activeStage].value = e;
      this.stages[this.activeStage].wordCount = this.$_wordWatch();
      let ToApiData = this.stages.map((x) => {
        return {
          section: { id: x.id, value: x.value, word_count: x.wordCount },
        };
      });
      this.$store.commit(
        "User/UPDATE_ADAPTATION_PLAN",
        ToApiData /* JSON.stringify(ToApiData) */
      );
      /*   if (this.wordCount >= this.stages[i].maxCount) {
        let filecont = this.editorQuill[this.activeStage].getText();
        this.editorQuill[i].disable()
      } else {
        this.stages[this.activeStage].value = e
        this.stages[this.activeStage].wordCount = this.wordCount
        let ToApiData = this.stages.map((x) => {
          return { id: x.id, value: x.value, wordCount:x.wordCount };
        });
        this.$store.commit("User/UPDATE_ADAPTATION_PLAN", JSON.stringify(ToApiData));
      } */
    },
    $_setView(v) {
      this.viewType = v;
      this.currentStep = 1;
    },
    $_saveToApi(v) {
      if (v) this.isProcessing = true;
      if (v) {
        setTimeout(() => {
          this.isProcessing = false;
          if (v)
            toastMessage(
              "Your data has been updated",
              false,
              false,
              "has-bottom-nav"
            );
        }, 1300);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.adaptation-plan {
  .adaptation-section {
    padding: 0 !important;
  }

  .or-text {
    padding-top: 24px;
    padding-bottom: 24px;
    font-size: 24px;
    text-align: center;
  }

  .content-container {
    max-width: 768px;
    position: relative;
    padding: 0 24px 24px;
    margin: auto;

    @media screen and (max-width: 680px) {
      padding: 0 16px 24px;
    }

    .section-title {
      font-size: 26px;
      margin: 24px 0px 2px;
      position: relative;

      @media screen and (max-width: 680px) {
        font-size: 22px;
        line-height: 24px;
      }
    }

    .close-btn {
      position: fixed;
      top: 74px;
      z-index: 9;
    }

    .save-btn {
      position: fixed;
      top: 76px;
      z-index: 9;
    }
  }

  .action-spacer {
    width: 100%;
    height: 66px;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.45px;
    /*     margin: 24px 0 12px 0;
    background: #fbd15e; */
    padding: 8px 12px;
    font-family: "Libre Franklin", sans-serif;
    border-radius: 5px;
  }

  .preview-title {
    font-size: 27px;
    font-weight: 500;
    font-family: serif;
  }

  .content {
    padding-bottom: 68px;
  }
}

.word-count {
  padding: 8px;
  margin-top: 7px;
  border-radius: 5px;
}

.step-navigation {
  //padding: 12px;
  position: relative;
  width: 100%;

  button {
    &:nth-of-type(2) {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    &:nth-of-type(3) {
      float: right;
    }
  }
}

.adapt-actions {
  @media screen and (max-width: 680px) {
    padding-top: 16px !important;
    text-align: center !important;
  }
}

.adaptation-plan-end {
  //margin-bottom: 64px;
  text-align: center;

  // padding: 24px;
  button {
    width: 200px;
  }
}

.print-btn {
  position: fixed;
  left: 50%;
  margin-top: 9px;
  transform: translateX(-50%);
}
</style>
<style lang="scss">
.adaptation-plan {
  .quillWrapper {
    border: 1px solid #e3e3e3;
    border-radius: 10px;
  }

  .ql-toolbar.ql-snow,
  .ql-container.ql-snow {
    border: none !important;
  }

  .ql-editor {
    min-height: 200px;
    font-size: 15px;
    background: white;
    border-radius: 0 0 12px 12px;

    p {
      margin-bottom: 9px;
    }
  }

  .description {
    padding: 0 10px;
    text-align: justify;
    font-size: 15px;

    p,
    ul,
    ol,
    li {
      font-size: 15px;
    }

    ul,
    ol {
      margin-top: 6px;
      padding-left: 16px;

      li {
        margin-bottom: 9px;
      }
    }
  }
}

.your-data-entry {
  img {
    max-width: 100%;
  }

  ul {
    margin-left: 36px;
    list-style-type: disc !important;

    li {
      list-style-type: disc !important;
    }
  }
}
</style>
